/* 
 * Lightcase
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
var $ = require('jquery');
require('lightcase');

// Modul construct
var somModul = {
	
	// Module name
	name: 'lightcase',
	
	// Items
	elements: null,
	
	// Init function
	init: function() {
		
		// Get component config
		var componentConfig = this.__getComponentConfig(somModul.name);
		if(componentConfig.enabled){
			
			// Get all elements
			somModul.elements = $(componentConfig.selector);
			
			// Default config for labels
			var config = {
				labels: {
					'errorMessage': this.lang.get('components.lightcase.errorMessage'),
					'sequenceInfo.of': this.lang.get('components.lightcase.sequenceInfo_of'),
					'close': this.lang.get('components.lightcase.close'),
					'navigator.prev':  this.lang.get('components.lightcase.prev'),
					'navigator.next':  this.lang.get('components.lightcase.next'),
					'navigator.play':  this.lang.get('components.lightcase.play'),
					'navigator.pause': this.lang.get('components.lightcase.pause')
				}
			};
			
			// Extend with custom config
			if(typeof componentConfig.config == 'object') {
				$.extend(true, config, componentConfig.config);
			}
			
			// Init lightcase
			somModul.elements.lightcase(config);
			
			return true;
		}
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;


/** WEBPACK FOOTER **
 ** ./src/components/lightcase.js
 **/